module.exports = __webpack_public_path__ + "img/nordur.13d8f12f.svg";